<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { api } from '../api';
  import { toastStore } from '../stores/toastStore';
  import { Modal, Button } from './ui/index';

  export let open = false;
  export let documentId: string;
  export let documentCategory: string | undefined = undefined;
  export let documentConfidence: number | undefined = undefined;
  export let householdId: string | undefined = undefined;

  const dispatch = createEventDispatcher<{ close: void }>();

  const categories = [
    'DocumentWrongCategory',
    'OcrTextNotRecognized',
    'ExtractedDataIncorrect',
    'WrongPersonAssignment',
    'Other',
  ] as const;

  let selectedCategory = '';
  let freeText = '';
  let submitting = false;

  function handleClose() {
    selectedCategory = '';
    freeText = '';
    dispatch('close');
  }

  async function handleSubmit() {
    if (!selectedCategory) return;

    submitting = true;
    try {
      await api.documents.submitFeedback(
        documentId,
        selectedCategory,
        freeText || undefined,
        documentCategory,
        documentConfidence,
        householdId,
      );
      toastStore.success($_('components.feedback_modal.success'));
      handleClose();
    } catch {
      // handleApiError already showed toast
    } finally {
      submitting = false;
    }
  }
</script>

<Modal {open} title={$_('components.feedback_modal.title')} on:close={handleClose}>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-text-secondary">
      {$_('components.feedback_modal.description')}
    </p>

    <fieldset class="flex flex-col gap-2">
      <legend class="text-xs font-semibold text-text-muted mb-1">
        {$_('components.feedback_modal.category_label')}
      </legend>
      {#each categories as cat (cat)}
        <label
          data-testid="feedback-category-{cat}"
          class="flex items-center gap-2 text-sm text-text cursor-pointer"
        >
          <input
            type="radio"
            name="feedback-category"
            value={cat}
            bind:group={selectedCategory}
            class="text-accent focus:ring-accent/30"
          />
          {$_(`components.feedback_modal.category_${cat}`)}
        </label>
      {/each}
    </fieldset>

    <div>
      <label class="text-xs font-semibold text-text-muted block mb-1" for="feedback-freetext">
        {$_('components.feedback_modal.freetext_label')}
      </label>
      <textarea
        id="feedback-freetext"
        data-testid="feedback-text-input"
        bind:value={freeText}
        rows="3"
        placeholder={$_('components.feedback_modal.freetext_placeholder')}
        class="w-full px-3 py-2 bg-bg-alt border border-border rounded text-sm text-text placeholder:text-text-muted focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 resize-y"
      ></textarea>
    </div>
  </div>

  <svelte:fragment slot="footer">
    <Button
      variant="primary"
      disabled={submitting || !selectedCategory}
      on:click={handleSubmit}
      data-testid="feedback-submit-button"
    >
      {submitting ? $_('messages.saving') : $_('components.feedback_modal.submit')}
    </Button>
    <Button variant="secondary" disabled={submitting} on:click={handleClose}>
      {$_('pages.settings.cancel')}
    </Button>
  </svelte:fragment>
</Modal>
